/* eslint-disable react-hooks/exhaustive-deps */
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { PATH_NAME, TITLES } from '../constants';

import { startConsultarCompromisos } from '../store';
import { Compromisos } from '../components/tables/Compromisos';

export function ListadoCompromisos() {
  const location = useLocation();
  const isListadoCompromisos = location?.pathname.includes(PATH_NAME.listado_de_compromisos);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(startConsultarCompromisos());
  }, []);

  return (
    <>
      <Helmet>
        <title> {isListadoCompromisos ? TITLES.listado_de_compromisos : TITLES.default} </title>
      </Helmet>

      <Compromisos />
    </>
  );
}
